$(document).ready(function() {
	if(!document.querySelector('.signup-wrap')) return false;
	
	// LGEUK-124 Start
	var countryCode = $('html').data('countrycode').toUpperCase();
	var cookieA = false;
	
	var emailAddressDiff = ''; //LGEGMC-2725
	
	// LGETH-120 Start
	if(countryCode == 'TH'){
		$("input:checkbox[id='signUp-chk1']").prop("checked", true);
		$("input:checkbox[id='signUp-chk2']").prop("checked", true);
	}
	// LGETH-120 End
	
	// LGEGMC-2449 Start
	var emailVerificationResult = false;
	// LGEGMC-2449 End

	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}	
	// LGEUK-124 End
	
	// PJTGPEMP-1 Start
	var empUseFlag = '';
	if(!document.getElementById('empUseFlag')){
		empUseFlag = 'N';
	}else{
		empUseFlag = document.getElementById('empUseFlag').value;  
	}
	// PJTGPEMP-1 End
	
	var mailSignCheck = false;
	if(countryCode == 'AU'){
		if(typeof $('#mailSignCheck').val() != 'undefined' && $('#mailSignCheck').val() == 'Y') mailSignCheck = true;
	}
	
	var form = {
		el: document.getElementById('signUpForm'),
		$selectors: null,
		init: function(){
			form.vnLangCheck();
			form.setBirthday();
			form.addEvent();
			form.$selectors = $(form.el).find('select');
			form.getCaptcha();
			form.viewPasswordRule(); // EMP 20220128 추가
			
		// START 전호근 - UI 변경건으로 추후 삭제 대기 중
			// form.setDatepicker();
		},
		// setDatepicker: function(){
		// 	var $birthPicker = $('#birthDate');
		// 	if ($birthPicker.length) {
		// 		$birthPicker.datepicker('option', 'maxDate', 0);
		// 	}
		// },
		// END 전호근 - UI 변경건으로 추후 삭제 대기 중
		setBirthday: function(){
			var ageLimitUrl = $('[data-age-limit]').data('url');
			$.ajax({
				type: "post",
				url: ageLimitUrl,
				async: false,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(res) {
					console.log(res);
					// 20200601 START 구유정 || res.limitAge 조건 변경
					// 20200608 START 구유정 || res.limitAgeTxt 조건 추가
					if(mailSignCheck){
						if ( res.result && res.limitAge >= 0 ){
							$('#birthDate').datePicker('setEndDate', '-' + ( res.limitAge + 1 ) + 'y' );
						}
					}else{
						if ( res.result && res.limitAge >= 0 ){
							if(res.limitAgeTxt && res.limitAgeTxt.length){
								var noticeTxt = '<p class="notice">'+ res.limitAgeTxt +'</p>';
								$('[data-age-limit]').find('.field-block').after( noticeTxt );
							}
							// 20200609 START 김우람 || limitAge 가 0 이상일때 나이제한 
							if ( res.limitAge == 0) {
								$('#birthDate').datePicker('setEndDate', '0y' );
							} else {
								$('#birthDate').datePicker('setEndDate', '-' + ( res.limitAge + 1 ) + 'y' );
							}
							// 20200609 END 김우람 || limitAge 가 0 이상일때 나이제한 
							
							$('[data-age-limit]').show();
						}
					}
					
					// 20200601 END 구유정 || res.limitAge 조건 변경
					// 20200608 END 구유정 || res.limitAgeTxt 조건 추가

					if ( res.result === false ){
						for (var key in res.error) {
							var $field = $(form.el).find('input[name="' + key + '"]');
							
							if ($field.length) {
								form.showError($field, '.ajax-msg', res.error[key]);
							}
						}
					}
					
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);
				}
			});

		},
		vnLangCheck: function(){
			// VN korean check
			var lang = $('html').attr('lang');
			if (countryCode == 'VN' && lang == 'KR'){
				$(form.el).append( '<input type="hidden" name="langType" value="kr">' );
			}
		},
		appendCaptcha: function(html){
			$('#captchaBox').empty();
			$('#captchaBox').append(html);
		},
		getCaptcha: function( showErrorCbFn ){
			if (typeof showErrorCbFn !== 'function'){
				showErrorCbFn = new Function();
			}
			var $form = $(form.el);
			var captchaUrl = $form.data('captchaUrl');

			if(!captchaUrl) return false;

			$.ajax({
				type: "post",
				url: captchaUrl,
				async: false,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					console.log(data);
					//$(sgin.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
					if (!!data.captchaHtml){
						var $csrf;
						if ( $form.find('[name=csrfToken]').length ){
							$csrf = $form.find('[name=csrfToken]').eq(0);
							$csrf.val( data.csrfToken );
						} else {
							$csrf = $('<input type="hidden" name="csrfToken">');
							$csrf.val( data.csrfToken );
							$form.append( $csrf );
						}
						
						form.appendCaptcha(data.captchaHtml);
						showErrorCbFn();
						
					}
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);

					alert('SYSTEM ERROR');
				}
			});


		},
		// EMP 20220128 START 박지영 - 비밀번호 규칙 내용 여닫기 기능 추가
		viewPasswordRule:function(){
			$('.password-info button[aria-expanded]').on('click', function() {
				var $button = $(this),
					$cont = $button.closest('.password-info').find('.password-info-cont');

				if ($cont.is(':visible')) {
					$button.attr('aria-expanded', false);
					$cont.stop().slideUp();
				} else {
					$button.attr('aria-expanded', true);
					$cont.stop().slideDown();
				}
			});
		},
		// EMP 20220128 END 박지영 - 비밀번호 규칙 내용 여닫기 기능 추가
		checkPassword: function(){
			var _this = form.el;
			var _fields = {
				password: $(_this).find('#txtBoxPassword').get(0),
				passwordConfirm: $(_this).find('#txtBoxPasswordConfirm').get(0)
			};
			var $block = $(_fields.password).parents('.field-block'),
				$confirmBlock = $(_fields.passwordConfirm).parents('.field-block');
			var result = true;
			
			var passwordResult = form.checkPasswordPattern(_fields.password.value);

			if(_fields.password.value != '' && passwordResult === true) {
				if(_fields.password.value == _fields.passwordConfirm.value) {
					$confirmBlock.removeClass('error');
				}else {
					$(_fields.passwordConfirm).focus();
					$confirmBlock.addClass('error').find('.match').show().siblings().hide();
					result = false;
				}
				$block.removeClass('error');
			}else {
				$(_fields.password).focus();
				$block.addClass('error').find('.invalid'+'.'+passwordResult).show().siblings().hide();
				result = false;
			}
			
			return result;
		},
		/* LGECI-133 20200827 add */
		chkPatternSerialStr: function(pw) {
			var pattern = [
				'1234567890',
				'abcdefghijklmnopqrstuvwxyz',  
				'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
				'qwertyuiopasdfghjklzxcvbnm',
				'QWERTYUIOPASDFGHJKLZXCVBNM',
			];

			return !!pattern.filter(function(pttnStr){
				var unit = 3;
				for (var i = 0, cnt = pttnStr.length - unit; i <= cnt ; i++) {
					if (pw.indexOf(pttnStr.substring(i, unit+i)) > -1) {
						return true;
					}
				}
				return false;
			}).length;
		},
		/* //LGECI-133 20200827 add */
		checkPasswordPattern: function(val){
			if (val) {
				var t = !1
				, n = /(abc)|(bcd)|(cde)|(def)|(efg)|(fgh)|(ghi)|(hij)|(ijk)|(jkl)|(klm)|(lmn)|(mno)|(nop)|(opq)|(pqr)|(qrs)|(rst)|(stu)|(tuv)|(uvw)|(vwx)|(wxy)|(xyz)|(qwer)|(wert)|(erty)|(rtyu)|(tyui)|(yuio)|(uiop)|(asdf)|(sdfg)|(dfgh)|(fghj)|(ghjk)|(hjkl)|(zxcv)|(xcvb)|(cvbn)|(vbnm)|(ABC)|(BCD)|(CDE)|(DEF)|(EFG)|(FGH)|(GHI)|(HIJ)|(IJK)|(JKL)|(KLM)|(LMN)|(MNO)|(NOP)|(OPQ)|(PQR)|(QRS)|(RST)|(STU)|(TUV)|(UVW)|(VWX)|(WXY)|(XYZ)|(QWER)|(WERT)|(ERTY)|(RTYU)|(TYUI)|(YUIO)|(UIOP)|(ASDF)|(SDFG)|(DFGH)|(FGHJ)|(GHJK)|(HJKL)|(ZXCV)|(XCVB)|(CVBN)|(VBNM)|(zyx)|(yxw)|(xwv)|(wvu)|(vut)|(uts)|(tsr)|(srq)|(rqp)|(qpo)|(pon)|(onm)|(nml)|(mlk)|(lkj)|(kji)|(jih)|(ihg)|(hgf)|(gfe)|(fed)|(edc)|(dcb)|(cba)|(poiu)|(oiuy)|(iuyt)|(uytr)|(ytre)|(trew)|(rewq)|(lkjh)|(kjhg)|(jhgf)|(hgfd)|(gfds)|(fdsa)|(mnbv)|(nbvc)|(bvcx)|(vcxz)|(ZYX)|(YXW)|(XWV)|(WVU)|(VUT)|(UTS)|(TSR)|(SRQ)|(RQP)|(QPO)|(PON)|(ONM)|(NML)|(MLK)|(LKJ)|(KJI)|(JIH)|(IHG)|(HGF)|(GFE)|(FED)|(EDC)|(DCB)|(CBA)|(POIU)|(OIUY)|(IUYT)|(UYTR)|(YTRE)|(TREW)|(REWQ)|(LKJH)|(KJHG)|(JHGF)|(HGFD)|(GFDS)|(FDSA)|(MNBV)|(NBVC)|(BVCX)|(VCXZ)|(012)|(123)|(234)|(345)|(456)|(567)|(678)|(789)|(890)|(987)|(876)|(765)|(654)|(432)|(321)|(210)/
				, r = /^[a-zA-Z]+$/
				, i = /^[\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/
				, s = /^[0-9]+$/
				, o = /^[a-zA-Z\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/
				, u = /^[0-9\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/
				, a = /^[a-zA-Z0-9]+$/
				, f = /^[a-zA-Z0-9\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/;

				var emailValue = '';
				if ($('#txtBoxEmail').length != 0) {
					emailValue = $(form.el).find('#txtBoxEmail').get(0).value;
				}
				if ($('#txtBoxVerificationEmail').length != 0) {
					emailValue = $(form.el).find('#txtBoxVerificationEmail').get(0).value;
				}

				var emailId = emailValue.split("@")[0];

				if (n.test(val) || val === emailValue || val === emailId) {
					return "formerror.password3";
				}

				if (val.length < 10) {
					if (r.test(val)) {
						return "formerror.password8";
					}
					if (i.test(val)) {
						return "formerror.password8";
					}
					if (s.test(val)) {
						return "formerror.password8";
					}
					if (o.test(val)) {
						return "formerror.password8";
					}
					if (u.test(val)) {
						return "formerror.password8";
					}
					if (a.test(val)) {
						return "formerror.password10";
					}
					if (f.test(val)) { 
						if (val.length < 8) {
							return "formerror.password8";
						}
						t = !0
					}
					return t == 1 ? !0 : "formerror.notsymbols"
				}
				return r.test(val) ? "formerror.password10" : i.test(val) ? "formerror.password10" : s.test(val) ? "formerror.password10" : o.test(val) ? "formerror.password10" : u.test(val) ? "formerror.password10" : (a.test(val) && (t = !0), f.test(val) && (t = !0), t == 1 ? !0 : "formerror.notsymbols")
			}
		},
		showError: function(_t, _target, _msg){
			var block = $(_t).parents(".field-block");

			if ( block.find(_target).length == 0 && _target == '.ajax-msg' ){
				block.find('.error-msg').append('<span class="ajax-msg"></span>');
			}		 

			block.addClass('error').find(_target).text(_msg).show().siblings().hide();
			$(_t).focus();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			
			/* LGEGMC-2725 Start */
			if(emailAddressDiff != '' && emailAddressDiff != $('#txtBoxVerificationEmail').val()){
				$('#divVerificationBtnArea').show();
				$('#txtBoxVerificationCode').val('');
				$('#btnConfirmVerification').prop('disabled', false);
			
				if(!$('#emailAddressDiff').length){
					var message = !!$('#txtBoxVerificationEmail').data('diff-error-text') ? $('#txtBoxVerificationEmail').data('diff-error-text') : 'Please verify the email address';
					var close = !!$('#txtBoxVerificationEmail').data('close-text') ? $('#txtBoxVerificationEmail').data('close-text') : 'Close';
					
					var modalHtml = '<div class="modal modal-simple fade" id="emailAddressDiff" tabindex="-1" role="dialog" data-backdrop="false" aria-describedby="emailAddressDiffDialog">'; 
					modalHtml += 	    '<div class="modal-dialog" role="document">';
					modalHtml +=	        '<div class="modal-content">';
					modalHtml +=	            '<div class="modal-body">';
					modalHtml +=	                '<div class="simple-content-box"><div class="content-paragraph" id="emailAddressDiffDialog">'+message+'</div></div>';
					modalHtml +=		        '</div>';
					modalHtml +=		        '<div class="modal-footer">';
					modalHtml +=	                '<button type="button" class="btn btn-primary" data-dismiss="modal">'+close+'</button>';
					modalHtml +=	            '</div>';
					modalHtml +=	        '</div>';
					modalHtml +=	    '</div>';
					modalHtml +=	'</div>';
					
					$('body').append(modalHtml)
				}
				
				/* Confirmed 활성화 */
				$('#txtBoxVerificationCode').attr('disabled', false);
				$('#divVerificationErrorMsg').find('.ajax-msg').removeClass('confirmed').hide();
				
				/* 이메일 확인 결과 저장 */
				emailVerificationResult = true;
				
				$('#emailAddressDiff').modal();
				
				return false;
			}
			/* LGEGMC-2725 End */

			var _this = e.currentTarget;
			var url = _this.getAttribute('data-url');
			
			var param = $(_this).serialize();
			// LGEITF-182 Start
			param+='&tdloginType=normal'; // LGEUK-124
			param+='&treasureType=signup';
			// LGEITF-182 End
			// LGEITF-491 start
			if( $("#txtBoxVerificationCode").length > 0){
				param+='&verificationCode='+$("#txtBoxVerificationCode").val();	
			}
			// LGEITF-491 end
			
			if($(_this).checkValidation()) {
				/* 이메일 인증되지 않으면 */
				if ($('#txtBoxVerificationEmail').length != 0) {
					if (!emailVerificationResult) {
						showAndHideElements($('#divVerificationErrorMsg'), 'show', 'required');
						return;
					}
				}

				$('body').trigger('ajaxLoadBefore');

				$.ajax({
					type: 'post',
					url: url,
					data: param,
					dataType: 'json',
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						// LGEHK-204 START
						if(data.migrationFlag == 'undefined' || data.migrationFlag == null){
							if (!data.result) {
								// LGECI-541 start
								if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
									if( !!$('#g-recaptcha').val()){
										reload_recaptcha_wrapper();
									}
								}
								// LGECI-541 end
								
								// LGEPA-473 start : test

	                        	if( data.error.code == "1009"){ // LGEGMC-2186
	                        		var _htm = "<form action='' id='signinForm' method='post'>"
	                        			_htm += "<fieldset>";
	                        		    _htm += "<input type='hidden' id='txtBoxEmail' name='emailAddr' value='"+data.error.mail+"'>";
	                        		    _htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
	                        		    _htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( data )+"'>";
	                            		_htm += "<input type='hidden' name='serverEnv' value='"+$("#signUpForm").find("input[name='serverEnv']").val()+"'>";
	                            		_htm += "</fieldset>";
	                            		_htm += "</form>";
	                            		
	                        		$('body').append(_htm);
	        						var loginform = $("#signinForm");
	        						loginform.attr("action",$("#signUpForm").attr("action").replace("/signUp","/login"));
	        						loginform.submit();
	                        		
	                        		return;	        					
	                        	}
	                        	// LGEPA-473 start : end

								// LGEGMC-2449 start
								if ((data.error.code == "1002" || data.error.code == "2002") && $('#divEmailErrorMsg').length != 0) {
									$('#divEmailErrorMsg').find('.ajax-msg').text(data.error.message);
									showAndHideElements($('#divEmailErrorMsg'), 'show', 'ajax-msg');
								}
								// LGEGMC-2449 end

								// LGEGMC-2112 Start
								if ((data.error.code == "1002" || data.error.code == "2002") && $('#signinEmailSendFieldBlock').length != 0) {
									var $emailFieldBlock = $('#signinEmailSendFieldBlock');

									$emailFieldBlock.find('.error-msg .ajax-msg').text(data.error.message).show();

									$emailFieldBlock.addClass('error');
									$emailFieldBlock.find('.error-msg').show();
								}
								// LGEGMC-2112 end
								
								// LGEITF-182, LGEGMC-4064 Start
								if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
									var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
									if(window.location.href.indexOf('/oauth/') >=0) {
										var actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
										if(actionURL.indexOf('wdev50.lg.com')>=0) {
											tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
										} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
											tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
										} else if(actionURL.indexOf('www.lg.com')>=0){
											tdFailUrl="https://www.lg.com"+tdFailUrl;
										}else{
											tdFailUrl="https://"+window.location.host+tdFailUrl;
										}
									}
									$.ajax({
									    type: 'post',
									    url: tdFailUrl,
									    dataType: 'json',
									    data: param,
									    xhrFields: {
											withCredentials: true
										},
									    async: false,
									    success: function(failData) {
									    	if(data.error.tdMessage){
									    		failData["failMessage"]=data.error.tdMessage;
									    	}else{
									    		failData["failMessage"]=data.error.message;
											}
											if(data.error.tdTypeFail){
												failData["tdTypeFail"]=data.error.tdTypeFail;
											}
									    	treasuredataInit(failData,'FAIL');
									    },
									    error: function(request,status,error) {
									        console.log("status: "+status);
									        console.log("error: "+error);
											$('body').trigger('ajaxLoadEnd');
									    }
									});
								//LGCOMITF-123-2 start
								} else if ( cookieA ) {
									var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
									if(window.location.href.indexOf('/oauth/') >=0) {
										var actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
										if(actionURL.indexOf('wdev50.lg.com')>=0) {
											tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
										} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
											tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
										} else if(actionURL.indexOf('www.lg.com')>=0){
											tdFailUrl="https://www.lg.com"+tdFailUrl;
										}else{
											tdFailUrl="https://"+window.location.host+tdFailUrl;
										}
									}
									$.ajax({
									    type: 'post',
									    url: tdFailUrl,
									    dataType: 'json',
									    data: param,
									    xhrFields: {
											withCredentials: true
										},
									    async: false,
									    success: function(failData) {
									    	if(data.error.tdMessage){
									    		failData["failMessage"]=data.error.tdMessage;
									    	}else{
									    		failData["failMessage"]=data.error.message;
											}
											if(data.error.tdTypeFail){
												failData["tdTypeFail"]=data.error.tdTypeFail;
											}
									    	nonTreasureDataInsertTable(failData);
									    },
									    error: function(request,status,error) {
									        console.log("status: "+status);
									        console.log("error: "+error);
											$('body').trigger('ajaxLoadEnd');
									    }
									});
								}
								// LGEITF-182, LGEGMC-4064 End	//LGCOMITF-123-2 end

								if (!data.error) {
									// system error
									var $errorModal = $("#errorModal");

									if (data.errorMessage) {
										$errorModal.find('.content-paragraph').text(data.errorMessage);
									} else {
										$errorModal.find('.content-paragraph').html('Sign up failed due to system error.<br>Please try again.');
									}

									$errorModal.modal('show'); 
								} else {
									// validation fail
									form.getCaptcha(function(){
										for (var key in data.error) {
											var $field = $(_this).find('input[name="' + key + '"]');
											
											if ($field.length) {
												form.showError($field, '.ajax-msg', data.error[key]);
											}
										}
									});
									//LGEITF-561 start
									if($('input[name=countryCode]').val() == 'CA' && $('.guide-password').length > 0){
										for (var key in data.error) {
											var $field = $(_this).find('input[name="' + key + '"]');
											if ($field.length) {
												form.showError($field, '.ajax-msg', data.error[key]);
												if(key=="password" && $field.parent().find('.error-msg').children('.guide-password').length > 0){ 
													showAndHideElements($('#txtBoxPassword').parent().find('.error-msg'), 'show', 'guide-password');
												}
											}
										}
									}
									//LGEITF-561 end
									// LGEGMC-2112 Start
									if ($('#divVerificationErrorMsg').length != 0) {
										$('#divVerificationErrorMsg').find('.ajax-msg').text(data.error.message);
										showAndHideElements($('#divVerificationErrorMsg'), 'show', 'ajax-msg');
									}
									// LGEITF-182 End
								}

								$('body').trigger('ajaxLoadEnd');
							} else {
								// successed
								// 20200406 START 김우람 || TH 가입후 설문조사 분기 추가 
								if (!!data.surveyFlag) {
									var authorizeKey = getUrlParams().authorizeKey;
									// 200421 START 전호근 - parameter 수정
									window.location.href = data.surveyUrl + '&authorizeKey=' + authorizeKey;
									// 200421 END 전호근 - parameter 수정

									$('body').trigger('ajaxLoadEnd');
								} else {
									if(empUseFlag != 'Y'){
										$(_this.submitData).val( JSON.stringify( data ) );
									}

									// LGEUK-124 Start
									if(typeof captcha == "undefined"){
										//LGEGMC-4064 start
										if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
											treasuredataInit(data, 'signUpNomalSubmit',_this);
											$('body').trigger('ajaxLoadEnd');
										}else{
											//LGCOMITF-123-2 start
											if ( cookieA ) {
												nonTreasureDataInsertTable(data);
											}
											//LGCOMITF-123-2 end
											_this.submit();
										}
										//LGEGMC-4064 end
									}else{
										if(captcha && captcha.validation()){
											//LGEGMC-4064 start
											if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
												treasuredataInit(data, 'signUpNomalSubmit',_this);
												$('body').trigger('ajaxLoadEnd');
											}else{
												//LGCOMITF-123-2 start
												if ( cookieA ) {
													nonTreasureDataInsertTable(data);
												}
												//LGCOMITF-123-2 end
												_this.submit();
											}
											//LGEGMC-4064 end
										} else if(!captcha) {
											//LGEGMC-4064 start
											if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
												treasuredataInit(data, 'signUpNomalSubmit',_this);
												$('body').trigger('ajaxLoadEnd');
											}else{
												//LGCOMITF-123-2 start
												if ( cookieA ) {
													nonTreasureDataInsertTable(data);
												}
												//LGCOMITF-123-2 end
												_this.submit(); // captcha가 없는 경우
											}
											//LGEGMC-4064 end
										}
									}
									// LGEUK-124 End
								}
								// 20200406 END 김우람 || TH 가입후 설문조사 분기 추가 

								/* dataLayer */
								// LGEUK-366, LGEIN-531 Start
								if ($('#txtBoxVerificationEmail').length != 0) {
									window.dataLayer.push({
										event: 'register_complete'
									});
								}

							}
						} else {
						
							if(data.status != null && data.redirectUrl != ''){
								location.href = data.redirectUrl;
							}
							
						}
						// LGEHK-204 END
					},
					error: function(request,status,error) {
						$('body').trigger('ajaxLoadEnd');
					},
					complete: function(){
					}
				});
			} else {
				// LGEGMC-2112 Start
				// CA 국가의 경우 required 클래스가 없고 guide-password 임
				if ($('#txtBoxPassword').val() == '' && $('input[name=countryCode]').val() == 'CA') {
					showAndHideElements($('#txtBoxPassword').parent().find('.error-msg'), 'show', 'guide-password');
				}

				if ($('input[name=countryCode]').val() == 'AR') {
					if ($('#txtBoxDocumentNumber') == '' || $(_this).val() == null) {
						showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'required');
					} else if (!/^[0-9]+$/.test($('#txtBoxDocumentNumber').val())) {
						showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'required-num');
					} else if ($('#txtBoxDocumentNumber').val().length != $('#txtBoxDocumentNumber').attr('minlength')) {
						showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'min-length invalid');
					}
				}
				// LGEGMC-2112 End
			}
		},
		addEvent: function(){
			$(form.el).on({
				submit: form.beforeSubmit
			});


			
			// 20200416 START 김우람 || SG 선호하는 연락수단 기능 추가
			$(form.el).find('.priority-list input').on('keydown', function(e) {
				var availables = [8,9,37,39,46,49,50,51,52,97,98,99,100];

				if (!(availables.indexOf(e.keyCode)+1)) return e.preventDefault();
			});

			$(form.el).find('.priority-list input').on('keyup', function(e) {
				$(this).val($(this).val().replace( /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' ));
			});

			$(form.el).find('.priority-list input').on('blur', function(e) {
				var $this = $(this),
					$siblings = $this.closest('.priority-list').find(':input').not($this),
					$modal = $('#priorityAlertModal'),
					_val = $this.val() || null;

				$siblings.each(function(idx, field) {
					if ($(field).val() === _val) { 
						$this.val('');
						$modal.modal('show');
					}
				});
			});

			$(form.el).on('submit.priority', function() {
				var $fields = $('.priority-list input');
				var userValues = ['1','2','3','4'];

				$fields.each(function(idx, field) {
					var _idx = userValues.indexOf($(field).val());
					if (_idx+1) {userValues.splice(_idx, 1);}
				});
				$fields.each(function(idx, field) {
					if (!$(field).val()) {$(field).val(userValues.shift())}
				});
			});
			// 20200416 END 김우람 || SG 선호하는 연락수단 기능 추가


			// $(form.el).on({
			// 	keydown: function(e){
			// 		if(e.keyCode==13 && e.currentTarget.value != '') {
			// 			if(!form.checkPassword()) {
			// 				e.preventDefault();
			// 			}
			// 		}
			// 	},
			// 	keyup: function (e) {
			// 		var _this = form.el;
			// 		var _fields = {
			// 			password: $(_this).find('#txtBoxPassword').get(0)
			// 		};
			// 		var $block = $(_fields.password).parents('.field-block');

			// 		if (form.checkPasswordPattern(_fields.password.value) === true) {
			// 			$block.removeClass('error');
			// 		}
			// 	}
			// }, 'input[type="password"]');

			$(form.el).on({
				"change.base": function(){
					form.$selectors.trigger('chosen:updated');
				}
			});
			
			// GP All Case | NL
			// checkbox 체크 시, input readonly 추가
			$(form.el).on({
				change: function(e){
					var _this = e.target,
						$target = $(_this.getAttribute("data-same-as-id"));

					!$target.data("isRequired") && $target.data("isRequired", $target.prop("required")); // 처음 한번만 실행

					if(_this.checked){
						$target.removeAttr("required");
						$target.val("").attr("readonly","readonly");
					}else{
						$target.data("isRequired") && $target.attr("required", "required");
						$target.removeAttr("readonly");
					}
				}
			}, '.same-as-input');

			// SNS SignUp | PL
			$(form.el).on('snsSignup', function( e, resultData ){
				console.log('snsSignup resultData', resultData );

				if( !form.el.submitData ){
					$(form.el).append( $('<input type="hidden" name="submitData">') );
				}
				var emailAccount = $(form.el).find('[name="emailAddr"]');					
				var $submitData = $(form.el).find("input[name='submitData']");

				if (emailAccount.length){
					emailAccount.val( resultData.emailAddr );
				}
				$submitData.val( JSON.stringify( resultData ) );

				var actionUrl = $('#signUpForm').attr('action').replace('signUp', 'login');

				$(form.el).attr('action' , actionUrl );
				form.el.submit();
				
			});

			// BR 개인/기업 선택
			$(form.el).on('click', '[data-personCheck]', function(){
				var select = $(this).attr('data-personCheck');
				// 20200311 START 김우람 || BR physical legal 버그 수정

				$('[data-personColumn]').find('.field-block').removeClass('error').end().find('.error-msg span').hide(); // LGEBR-829

				switch (select) {
					case 'Individual' :
						$('[data-personColumn="Individual"]').find('input[type="text"]').prop('disabled', false);
						$('[data-personColumn="legal"]').find('input[type="text"]').val('').prop('disabled', true).end().find('[data-freeCheck="checkbox"]').hide();
					break;
					case 'legal' :
						$('[data-personColumn="legal"]').find('input[type="text"]').prop('disabled', false).end().find('[data-freeCheck="checkbox"]').show();	
						$('[data-personColumn="Individual"]').find('input[type="text"]').val('').prop('disabled', true);
					break;
				}
				// 20200311 END 김우람 || BR physical legal 버그 수정
			});
			$(form.el).on('click', '[data-freeCheck="select"] > input[type="checkbox"]', function(){
				var field = $('[data-freeCheck="input"]');
				var text =  $(this).parent().find('.text').text();

				if($(this).prop('checked') == true){
					field.prop('readonly', true).val(text);
				}else{
					field.prop('readonly', false).val('');
				}
			});

			//Start LGEGMC-2112
			if ($("#birthDate").length != 0) {
				$("#birthDate").on('change', function(e) {
					var $fb = mailSignCheck ? $("#birthDate").parent() : $("#birthDate").parent().parent();
					showAndHideElements($fb.find('.error-msg'), 'hide', '');
					if ($fb.hasClass("error")) {
						$fb.removeClass("error");
					}
				});
			}

			$(form.el).on('focusout', function(e) {
				var _this = e.target;
				var _id = _this.id;

				if (!$(_this).prop('required')) {
					return;
				}
				
				console.log('tag id ---' + _id);
				
				var emailAddrPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				switch (_id) {
					case 'txtBoxEmail':
						$(_this).val($.trim($(_this).val())) // LGEBR-1147 : 이메일 Trim() 이벤트 추가
						if ($(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');			
							return;
						} else {
							showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
						}
			
						if (!emailAddrPattern.test($(_this).val())) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'invalid');			
							return;
						}

						if (typeof $(_this).attr('data-url') != 'undefined') {			
				
							var	url = $(_this).attr('data-url');
							var param = {"emailAddr" : xssfilter($(_this).val()) , "snsFlag" : "Y"};
						
							$.ajax({
								type: 'post',
								url: url,
								data: param,
								dataType: 'json',
								xhrFields: {
									withCredentials: true
								},
								success: function(res) {
									console.log(res);

									// LGEPA-473 start : test
									if (res.error.code == "1009") {
										var _htm = "<form action='' id='signinForm' method='post'>"
											_htm += "<fieldset>";
											_htm += "<input type='hidden' id='txtBoxEmail' name='emailAddr' value='"+res.error.mail+"'>";
											_htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
											_htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( res )+"'>";
											_htm += "<input type='hidden' name='serverEnv' value='"+$("#resendResetPasswordForm").find("input[name='serverEnv']").val()+"'>";
											_htm += "</fieldset>";
											_htm += "</form>";
											
										$('body').append(_htm);
										var form = $("#signinForm");
										form.attr("action",$("#resendResetPasswordForm").attr("action").replace("/forgotPassword","/login"));
										form.submit();
										
										return;
									}
									// LGEPA-473 end

									if (res.error.code == "5001") {
										showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
									} else {
										showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'already');			
									}
								},
								error: function(request, status, error) {
									console.log(error);
								}
							});
						}
						break;
					case 'txtBoxPassword':
						var retVal = form.checkPasswordPattern($(_this).val());
						console.log('retVal --- ' + retVal);

						// $('input[name=countryCode]').val() == 'CA'

						if (retVal == undefined) {
							if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'guide-password');
							} else {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							}
						} else if (retVal == true) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							//LGEITF-561 start
							if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', 'guide-password');
							}
							//LGEITF-561 end
						} else {
							retVal = 'invalid ' + retVal.replace('.', ' ');
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', retVal);
							//LGEITF-561 start
							if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'guide-password');
							}
							//LGEITF-561 end
						}
						break;
					case 'txtBoxPasswordConfirm':
						if ($(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
						} else {
							if ($('#txtBoxPassword').val() != $(_this).val()) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'match');
							} else {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							}
						}
						break;
					case 'txtBoxDocumentNumber':
						if ($(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
						} else if (!/^[0-9]+$/.test($(_this).val())) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required-num');
						} else if ($(_this).val().length != $(_this).attr('minlength')) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'min-length invalid');
						} else {
							showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
						}

						break;
					// LGEBR-829 Start
					// citizenshipNo : submit -(ACCCommonCodes.SsoStatusCode.SIGN_UP_05 = 2005 > duplicated fail) + form-validation > fail 참고
					// cnpj_no : submit - form-validation > fail 참고
					// 단순 null(required) error 상태일 때만 null 체크 > msg element hide
					// showAndHideElements 함수 hide 사용 시, .error-msg 자체가 hide 되어 ajax msg(citizenshipNo) 버그 발생하여 미사용
					case 'citizenshipNo':
						if ($(_this).val().indexOf('_') != -1 || $(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
						} else if ($(_this).next('.error-msg').find('.required').is(':visible')) {
							$(_this).parent().find('.error-msg span').hide();
						}
						break;
					case 'cnpj_no':
						if ($(_this).val().indexOf('_') != -1 || $(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
						} else if ($(_this).next('.error-msg').find('.required').is(':visible')) {
							$(_this).parent().find('.error-msg span').hide();
						}
						break;
					// LGEBR-829 End
					default:
						if ($(_this).val() == '' || $(_this).val() == null) {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'show', 'required');
							}
						} else {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'hide', '');
							}
						}
				}
			});
			//End LGEGMC-2112

			// LGECO-166 Start
			if(countryCode == 'CO') {
				$('#txtBoxRegion').change(function() {
					$.ajax({
						type: 'post',
						url: $('#txtBoxRegion').data('url'),
						data: { "addressLine1Info" : $(this).val() },
						dataType: 'json',
						xhrFields: {withCredentials: true},
						success: function(stateSata) {
							console.log(stateSata);

							/*
							 * reset data
							 */
							$('#txtBoxCity').empty();
							$('#txtBoxCity').append('<option disabled selected value="">' + $('#txtBoxCity').data('placeholder') + '</option>');
							$('#txtBoxCity').trigger('chosen:updated');

							$('#txtBoxStateName').empty();
							$('#txtBoxStateName').append('<option disabled selected value="">' + $('#txtBoxStateName').data('placeholder') + '</option>');

							/*
							 * set option data
							 */
							stateSata.forEach(function(sdata, idx) {
								for (var key in sdata) {
									console.log(key + ' -> ' + sdata[key]);
									$('#txtBoxStateName').append('<option value="' + key + '">' + sdata[key] + '</option>');
								}
							});
							$('#txtBoxStateName').trigger('chosen:updated');
						},
						error: function(request, status, error) {
							console.log(error);
						}
					});
				});

				$('#txtBoxStateName').change(function() {
					$.ajax({
						type: 'post',
						url: $('#txtBoxStateName').data('url'),
						data: { "cityName" : $(this).val() },
						dataType: 'json',
						xhrFields: {withCredentials: true},
						success: function(cityData) {
							console.log(cityData);

							/*
							 * reset data
							 */
							$('#txtBoxCity').empty();
							$('#txtBoxCity').append($('<option>', {
								value: '',
								text : $('#txtBoxCity').data('placeholder'),
								disabled: true,
								selected: true
							}));

							/*
							 * set option data
							 */
							cityData.forEach(function(cdata, idx) {
								for (var key in cdata) {
									console.log(key + ' -> ' + cdata[key]);
									$('#txtBoxCity').append($('<option>', {
										value: key,
										text : cdata[key]
									}));
								}
							});
							$('#txtBoxCity').trigger('chosen:updated');
						},
						error: function(request, status, error) {
							console.log(error);
						}
					});
				});
			}
			// LGECO-166 End

			/* LGEGMC-2725 End */
			$(document).on('hidden.bs.modal', '#emailAddressDiff', function(e) {
				$('#txtBoxVerificationEmail').focus();
			});
			/* LGEGMC-2725 Start */
		}
	};

	form.init();
	
	//PJTGPEMP-1 Start
	if(empUseFlag == 'Y'){
		if (document.querySelector('input.email')) { 
			$('button[type="submit"]').attr('disabled', true); 
			var oldVal = '';
	        var duplicateUser = {
	            el: document.querySelector('input.email'),
	            check : document.getElementById('check-availability'),
	            init: function () {
	                $(duplicateUser.check).on({
	                    click: function (e) {
	                        e.preventDefault();
	                        var _this = document.getElementById('signUpForm');
	                        if ($(document.getElementById('txtBoxEmail')).checkValidation()) {
	                            var url = _this.getAttribute('check-data-url');
	                            var param = xssfilter($(_this).serialize());
	                            var methodType = $(_this).data('ajaxMethod');
	
	                            $('body').trigger('ajaxLoadBefore');
	                            ajax.call(url, param, 'json', function (data) {
	                                $('body').trigger('ajaxLoadEnd');
	                                $("#txtBoxEmail").siblings('.error-msg').find('span').hide();
	                                if (data) {
	                                	if(data.returnCode == 200){
	                                		$('#modal-available-user').modal('show');
	                                		$('button[type="submit"]').attr('disabled', false); 
	                                		oldVal = $(duplicateUser.el).val();
	                                	}else if(data.returnCode == 406){
	                                		//$('.error-msg .ajax-msg').text(data.returnMessage);
	                                		//$("#txtBoxEmail").siblings('.error-msg').show().find('.ajax-msg').show();
	                                		$('#modal-duplicate-user').modal('show');
	                                		$('button[type="submit"]').attr('disabled', true); 
	                                	}else{
	                                		//$('.error-msg .ajax-msg').hide();
	                                	}
	                                }else{
	                                	$('.error-msg .ajax-msg').text('error');
	                            		$('.error-msg .ajax-msg').show();
	                            		$('button[type="submit"]').attr('disabled', true); 
	                                }
	                            }, methodType);
	                        }
	                    }
	                });
	                $(duplicateUser.el).on("propertychange change keyup paste input", function() {
	                	var currentVal = $(this).val();
	                    if(currentVal == oldVal) {
	                    	$('button[type="submit"]').attr('disabled', false); 
	                        return;
	                    }
	                	$('button[type="submit"]').attr('disabled', true); 
	                });
	            }
	        };
	        
	        duplicateUser.init();
	    }
	}
	
	$("#lgaccountAddService").on("click", function(){

		var _this = $('#lgaccountAddForm');
        console.log(_this);
		var param = $(_this).serialize();
        console.log(param);
		
		if(!$(_this).checkValidation()) {
			return false;
		}
	})
	//PJTGPEMP-1 End
	
	$(".accordion-wrap").on("click", ".link-text", function(){
		var $this = $(this);
		var $group = $this.closest(".accordion-group");
		if(!$group.hasClass("open")){
			$this.addClass("active");
			$this.attr('aria-expanded', true);
			$group.addClass("open").find(".accordion-content").stop().slideDown();
		}else{
			$this.removeClass("active");
			$this.attr('aria-expanded', false);
			$group.removeClass("open").find(".accordion-content").stop().slideUp();
		}
	})
	// LGEUK-124 Start 
	// Treasure Data Tracking
	var td_client_id_cookie = '';
	var td_global_id = '';
	var td_ssc_id = '';
	function getCookieTd(name) {
		if ($.cookie(name)) {
			return decodeURIComponent($.cookie(name));
		} else {
			$.cookie(name);
		}
	}
	function treasuredataInit(resultData, type, _this) {
	  	var tdLoginStatus = new Treasure({ // LGEITF-182
		    host: 'eu01.in.treasuredata.com',
		    writeKey: resultData.apikey,
		    database: resultData.database,
		    sscDomain: 'lg.com',
		    sscServer: 'ssc.lg.com',
		    useServerSideCookie: true
		});

	  	tdLoginStatus.setSignedMode(); // LGEITF-182

		// Enable cross-domain tracking
		tdLoginStatus.set('$global', 'td_global_id', 'td_global_id'); // LGEITF-182
	    
	    var successCallback_ssc = function (serverSideId) {
	    	td_ssc_id = serverSideId;
	    	console.log('successCallback_ssc');
	    	tdLoginStatus.fetchGlobalID(successCallback, errorCallback);
    	};
    	var errorCallback_ssc = function (error) {
		  console.log('errorCallback_ssc :: ' + error);
		}
    	tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc); // LGEITF-182

	    // Receive td_global_id
	    var successCallback = function(td_global_id_data) {

			td_global_id = td_global_id_data;
			td_client_id_cookie = getCookieTd('_td');
			
			treasuredataAjax(resultData);
		
			// LGEITF-182 Start
			if(type != 'FAIL'){
				_this.submit();
			}
			// LGEITF-182 End
	    };
	    var errorCallback = function(err) {
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
			
			// LGEITF-182 Start
			if(type != 'FAIL'){
				_this.submit();
			}
			// LGEITF-182 End
	    };

	}

	function treasuredataAjax(resultData){
		var treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/';
			treasuredataUrl += resultData.table+ '?';
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+td_client_id_cookie;
			treasuredataUrl += '&td_global_id='+td_global_id;
			treasuredataUrl += '&td_ssc_id='+td_ssc_id;
		
			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End

		if(cookieA && treasureDataFlag == 'Y'){
			$.ajax({
			    url : treasuredataUrl,
			    type : 'POST',
			    dataType : 'jsonp',
				jsonpCallback: "callback",
				async: false,
			    crossDomain: true,
			    beforeSend: function (xhr) {
					xhr.setRequestHeader("Content-type","application/json");
					xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
				},
			    success : function(data){
	//				console.log(data);
					console.log("treasuredata post success"); // LGEIN-239
			    	
				}
			});
		}
		
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		if(resultData.apikey)
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
		if(td_client_id_cookie)
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent(td_client_id_cookie);
		if(td_global_id)
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent(td_global_id);
		if(td_ssc_id)
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(td_ssc_id);
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 start
	function nonTreasureDataInsertTable(resultData){
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		
		//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
		treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
		
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 end
	function nvl(str, defaultStr){
		var check = str+"";
		var result = "";
		check = check.trim()
		if(check=="" || check==null || check == "null" || check=="undefined"){
			result = defaultStr;
		}else{
			result = check;
		}
		return result ;
	}
	// LGEUK-124 End

	// LGEPA-204 Start
    var passwordView =  function() {
        var el = $('.password-util');
        var btn = el.find('.btn-eyes');
        var hide = el.find('.txt-hide').text();
        var show = el.find('.txt-show').text();
        var input = el.prev('input');

        btn.attr('aria-label', hide);
        
        btn.on('click', function(e){
            e.preventDefault();
            if($(this).is('.show')){
                $(this).removeClass('show').attr('aria-label', hide);
                input.attr('type', 'password');
            }else{
                $(this).addClass('show').attr('aria-label', show);
                input.attr('type', 'text');
            }

			btn.focus();
        });
    }
	passwordView();

    var passwordConfirmView =  function() {
        var el = $('.password-confirm-util');
        var btn = el.find('.btn-eyes');
        var hide = el.find('.txt-hide').text();
        var show = el.find('.txt-show').text();
        var input = el.prev('input');

        btn.attr('aria-label', hide);
        
        btn.on('click', function(e){
            e.preventDefault();
            if($(this).is('.show')){
                $(this).removeClass('show').attr('aria-label', hide);
                input.attr('type', 'password');
            }else{
                $(this).addClass('show').attr('aria-label', show);
                input.attr('type', 'text');
            }

			btn.focus();
        });
    }
	passwordConfirmView();
	// LGEPA-204 End

	//LGEPA-204 start
	$(".trigger-btn").on("click", function(){
		var $this = $(this);
		var $group = $this.closest(".form-trigger").next('[class*="column-"]');
		if(!$group.hasClass("show")){
			$this.addClass("active").attr('aria-expanded', true);
			$this.find("span").text("hide");
			$group.addClass("show").removeClass("hide").stop().slideDown();
		}else{
			$this.removeClass("active").attr('aria-expanded', false);
			$this.find("span").text("show");
			$group.removeClass("show").stop().slideUp();
		}
	})
	//LGEPA-204 end

	//LGEKZ-103 start
	var isKZ = '';
	if (document.getElementById('serviceLocale')) {
		isKZ = document.getElementById('serviceLocale').value;  
	}

	if (isKZ == 'kz') {
		$('#txtBoxCountry').on('change', function() {
			$('#txtBoxVerificationEmail').attr('disabled', false);
			$('#txtBoxVerificationCode').attr('disabled', false);
			$('#txtBoxPassword').attr('disabled', false);
			$('#txtBoxPasswordConfirm').attr('disabled', false);
			$('#txtBoxFName').attr('disabled', false);
			$('#txtBoxLName').attr('disabled', false);
			$('#txtBoxPostCode').attr('disabled', false);
			$('#txtBoxTelephoneNumber').attr('disabled', false);
			$('#txtBoxMobilePhone').attr('disabled', false);
			$('#signUp-chk1').attr('disabled', false);
			$('#signUp-chk2').attr('disabled', false);
		});

		if ($('input[name=visitorcountry]').val() == 'KZ') {
			$('#txtBoxCountry option').each(function(index, element) {
				if (!(element.value == 'Select' || element.value == 'KZ')) {
					$(this).remove();
				}
			});
		}
	}
	//LGEKZ-103 end

	// LGEUK-366, LGEIN-531 Start
	var emailVerificationTimer;
	var emailVerificationSent = new Date(1970, 1, 1);
	var emailVerificationSentEmail = '';
	if ($('#txtBoxVerificationEmail').length != 0) {
		$('#btnEmailVerificationSend').click(function(verificationSendEvent) {
			var divErrorMsg = $('#divEmailErrorMsg');
			
			/* 이메일 형식 검사 */
			$('#txtBoxVerificationEmail').val($.trim($('#txtBoxVerificationEmail').val())) // LGEBR-1147 : 이메일 Trim() 이벤트 추가
			
			var verifyEmailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!verifyEmailPattern.test($('#txtBoxVerificationEmail').val())) {
				showAndHideElements(divErrorMsg, 'show', 'invalid');
				return;
			}

			/* 메일 전송 확인 */
			var nowDateTime = Date.now();
			if (emailVerificationSent.getTime() == (new Date(1970, 1, 1)).getTime() && emailVerificationSentEmail == '') {
				emailVerificationSent.setTime(nowDateTime);
				emailVerificationSentEmail = $('#txtBoxVerificationEmail').val();
			} else {
				if ((nowDateTime - emailVerificationSent.getTime()) / 1000 < 60 && emailVerificationSentEmail == $('#txtBoxVerificationEmail').val()) {
					console.log('It\'s been less than a minute since the mail was sent.');
					showAndHideElements(divErrorMsg, 'show', 'wait-a-minute');
					return;
				}
				emailVerificationSent.setTime(nowDateTime);
				emailVerificationSentEmail = $('#txtBoxVerificationEmail').val();
			}

			/* 타이머 초기화 */
			clearInterval(emailVerificationTimer);
			$('#spnVerificationTimer').text('00:00');

			/* 메시지를 초기화 */
			showAndHideElements(divErrorMsg, 'hide', '');

			/* inbox 버튼을 초기화 */
			if ($('#btnGotoInbox').length != 0) {
				$('#btnGotoInbox').remove();
			}

			var reqUrl = $('#txtBoxVerificationEmail').attr('data-verification-url');
			var inboxUrl = $('#txtBoxVerificationEmail').attr('data-inbox-url'); // LGEGMC-2724
			var param = 'emailAddr=' + $('#txtBoxVerificationEmail').val();
			$.ajax({
				type: 'post',
				url: reqUrl,
				data: param,
				dataType: 'json',
				xhrFields: {
					withCredentials: true
				},
				beforeSend: function(xhr){ // LGEGMC-2724 : beforeSend 추가
					if( inboxUrl != undefined && inboxUrl != ""){
						$.ajax({
							type: 'post',
							url: inboxUrl,
							data: param,
							dataType: 'json',
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								console.log(data);

								if(data.status == 'success') {
									/* Resend로 변경 */
									var resendEmailBtnText = 'RESEND EMAIL';
									if (typeof $("#btnEmailVerificationSend").data('alt-text') !== 'undefined') {
										resendEmailBtnText = $("#btnEmailVerificationSend").data('alt-text');
									}

									$(verificationSendEvent.currentTarget).html(resendEmailBtnText);
									if ($(verificationSendEvent.currentTarget).hasClass("btn-primary")) {
										$(verificationSendEvent.currentTarget).removeClass("btn-primary");
										$(verificationSendEvent.currentTarget).addClass("btn-secondary");
									}
									showAndHideElements(divErrorMsg, 'show', 'notice email-sent');

									/* 타이머 작동 */
									verificationTimer(1 / 6);

									/* OK 버튼 활성화 */
									$('#txtBoxVerificationCode').attr('disabled', false);
									$('#btnConfirmVerification').attr('disabled', false);
									if ($('#btnConfirmVerification').prev().hasClass('confirmed')) {
										$('#btnConfirmVerification').prev().removeClass('confirmed');
									}

									/* GO TO INBOX 버튼 추가 */
									if (data.goToInboxUrl != '' && $('#btnGotoInbox').length == 0) {
										var gotoInboxBtnText = 'GO TO INBOX';
										if (typeof $("#btnEmailVerificationSend").data('inbox-text') !== 'undefined') {
											gotoInboxBtnText = $("#btnEmailVerificationSend").data('inbox-text');
										}

										// Start LGEGMC-2339 (CA의 경우 버튼 스타일이 다름)
										var btnInboxClass = 'btn btn-primary btn-lg';
										if ($('input[name=countryCode]').val() == 'CA') {
											btnInboxClass = 'btn btn-primary btn-lg btn-block';
										}
										// End LGEGMC-2339

										var gotoInboxBtn = $('<button />', {
											type: 'button',
											id: 'btnGotoInbox',
											class: btnInboxClass,
											text: gotoInboxBtnText,
											on: {
												click: function (gotoInboxEvent) {
													console.log(data.goToInboxUrl);
													window.open('http://' + data.goToInboxUrl);

													if ($(gotoInboxEvent.currentTarget).hasClass("btn-primary")) {
														$(gotoInboxEvent.currentTarget).removeClass("btn-primary");
														$(gotoInboxEvent.currentTarget).addClass("btn-outline-secondary");
													}

													/* dataLayer */
													window.dataLayer.push({
														event: 'signup_goto_inbox'
													});
												}
											}
										});
										$('#divVerificationBtnArea').append(gotoInboxBtn);
									} else {
									}

								} else if (data.status == 'fail' && data.message == 'email duplicate') {
									showAndHideElements(divErrorMsg, 'show', 'already');
									xhr.abort(); 
								} else if (data.status == 'fail') {
									$('#divEmailErrorMsg').find('.ajax-msg').text(data.message);
									showAndHideElements(divErrorMsg, 'show', 'ajax-msg');
									xhr.abort(); 
								} else {
									xhr.abort(); 
								}
							},
							error: function(request, status, error) {
								console.log(error);
								xhr.abort(); 
							}
						});
					}
				},
				success: function(data) {
					console.log(data);

					if(data.status == 'success') {
						if( inboxUrl == undefined || inboxUrl == ""){
							/* Resend로 변경 */
							var resendEmailBtnText = 'RESEND EMAIL';
							if (typeof $("#btnEmailVerificationSend").data('alt-text') !== 'undefined') {
								resendEmailBtnText = $("#btnEmailVerificationSend").data('alt-text');
							}

							$(verificationSendEvent.currentTarget).html(resendEmailBtnText);
							if ($(verificationSendEvent.currentTarget).hasClass("btn-primary")) {
								$(verificationSendEvent.currentTarget).removeClass("btn-primary");
								$(verificationSendEvent.currentTarget).addClass("btn-secondary");
							}
							showAndHideElements(divErrorMsg, 'show', 'notice email-sent');

							/* 타이머 작동 */
							verificationTimer(1 / 6);

							/* OK 버튼 활성화 */
							$('#txtBoxVerificationCode').attr('disabled', false);
							$('#btnConfirmVerification').attr('disabled', false);
							if ($('#btnConfirmVerification').prev().hasClass('confirmed')) {
								$('#btnConfirmVerification').prev().removeClass('confirmed');
							}

							/* GO TO INBOX 버튼 추가 */
							if (data.goToInboxUrl != '' && $('#btnGotoInbox').length == 0) {
								var gotoInboxBtnText = 'GO TO INBOX';
								if (typeof $("#btnEmailVerificationSend").data('inbox-text') !== 'undefined') {
									gotoInboxBtnText = $("#btnEmailVerificationSend").data('inbox-text');
								}

								// Start LGEGMC-2339 (CA의 경우 버튼 스타일이 다름)
								var btnInboxClass = 'btn btn-primary btn-lg';
								if ($('input[name=countryCode]').val() == 'CA') {
									btnInboxClass = 'btn btn-primary btn-lg btn-block';
								}
								// End LGEGMC-2339

								var gotoInboxBtn = $('<button />', {
									type: 'button',
									id: 'btnGotoInbox',
									class: btnInboxClass,
									text: gotoInboxBtnText,
									on: {
										click: function (gotoInboxEvent) {
											console.log(data.goToInboxUrl);
											window.open('http://' + data.goToInboxUrl);

											if ($(gotoInboxEvent.currentTarget).hasClass("btn-primary")) {
												$(gotoInboxEvent.currentTarget).removeClass("btn-primary");
												$(gotoInboxEvent.currentTarget).addClass("btn-outline-secondary");
											}

											/* dataLayer */
											window.dataLayer.push({
												event: 'signup_goto_inbox'
											});
										}
									}
								});
								$('#divVerificationBtnArea').append(gotoInboxBtn);
							} else {
							}
						}
					} else if (data.status == 'fail' && data.message == 'email duplicate') {
						showAndHideElements(divErrorMsg, 'show', 'already');
					} else if (data.status == 'fail') {
						$('#divEmailErrorMsg').find('.ajax-msg').text(data.message);
						showAndHideElements(divErrorMsg, 'show', 'ajax-msg');
					} else {
					}
				},
				error: function(request, status, error) {
					console.log(error);
				}
			});

		});

		$('#btnConfirmVerification').click(function(verificationConfirmEvent) {
			console.log('Request email verification code.');

			/* 메시지를 초기화 */
			var divVerificationErrorMsg = $('#divVerificationErrorMsg');
			showAndHideElements(divVerificationErrorMsg, 'hide', '');

			var reqUrl = $('#txtBoxVerificationCode').attr('data-confirmation-url');
			var param = 'emailAddr=' + $('#txtBoxVerificationEmail').val() + '&verificationCode=' + $('#txtBoxVerificationCode').val();
			$.ajax({
				type: 'post',
				url: reqUrl,
				data: param,
				dataType: 'json',
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					console.log(data);

					/* display ajax message */
					if ($('#divVerificationErrorMsg').find('.ajax-msg').hasClass("confirmed")) {
						$('#divVerificationErrorMsg').find('.ajax-msg').removeClass("confirmed")
					}
					$('#divVerificationErrorMsg').find('.ajax-msg').text(data.message);
					showAndHideElements(divVerificationErrorMsg, 'show', 'ajax-msg');

					if(data.status == 'success') {
						/* 타이머 초기화 */
						clearInterval(emailVerificationTimer);
						$('#spnVerificationTimer').text('00:00');

						/* Confirmed 비활성화 */
						$('#txtBoxVerificationCode').attr('disabled', true);
						$(verificationConfirmEvent.currentTarget).attr('disabled', true);
						$('#divVerificationErrorMsg').find('.ajax-msg').addClass('confirmed');
						
						/* LGEGMC-2725 Start */
						$('#divVerificationBtnArea').hide();
						emailAddressDiff = $('#txtBoxVerificationEmail').val();
						/* LGEGMC-2725 End */

						/* 이메일 확인 결과 저장 */
						emailVerificationResult = true;

						/* dataLayer */
						window.dataLayer.push({
							event: 'signup_pincode_check',
							checkResult: 'success'
						});

					} else {
						/* 이메일 확인 결과 저장 */
						emailVerificationResult = false;

						/* dataLayer */
						window.dataLayer.push({
							event: 'signup_pincode_check',
							checkResult: 'fail'
						});
					}
				},
				error: function(request, status, error) {
					console.log(error);
				}
			});
		});
	}
	function verificationTimer(duration) {
		var timer = duration * 3600;
		var minutes, seconds;

		emailVerificationTimer = setInterval(function(){
			minutes = parseInt(timer / 60 % 60, 10);
			seconds = parseInt(timer % 60, 10);

			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;

			$('#spnVerificationTimer').text(minutes + ":" + seconds);

			if (--timer < 0) {
				timer = 0;
				clearInterval(emailVerificationTimer);
				$('#btnConfirmVerification').attr('disabled', true);
			}
		}, 1000);
	}

	function showAndHideElements(targetObject, toggle, targetElement) {
		targetObject[toggle == 'show' ? 'show' : 'hide']();

		targetObject.children().each(function (index, item) {
			var className = $(item).attr('class');
			if (className == targetElement) {
				$(item)[toggle == 'show' ? 'show' : 'hide']();
			} else {
				$(item).hide();
			}
		});
	}
	// LGEUK-366, LGEIN-531 End
});
